/** Iconos raster en `public/icons` (set flat teal MLV). */
export const MLV_PNG = Object.freeze({
  home: '/icons/home.png',
  login: '/icons/login.png',
  shop: '/icons/shop.png',
  message: '/icons/message.png',
  edit: '/icons/edit.png',
  whatsapp: '/icons/whatsapp.png',
  profile: '/icons/profile.png',
  servicios: '/icons/servicios.png',
  menu: '/icons/menu.png',
  calendar: '/icons/calendar.png',
});

/**
 * @param {keyof typeof MLV_PNG} key
 * @param {string} [extraClass]
 * @param {{ w?: number, h?: number, alt?: string }} [opts]
 */
export function mlvPng(key, extraClass = '', opts = {}) {
  const src = MLV_PNG[key];
  if (!src) throw new Error(`mlvPng: clave desconocida: ${key}`);
  const w = opts.w ?? 24;
  const h = opts.h ?? 24;
  const alt = opts.alt ?? '';
  const cls = `mlv-png-icon${extraClass ? ` ${extraClass}` : ''}`;
  return `<img src="${src}" alt="${alt}" width="${w}" height="${h}" decoding="async" draggable="false" class="${cls}" />`;
}

/** Barra inferior: opacidad con `.mlv-nav-item` / `.mlv-nav-active` + `.mlv-nav-png`. */
export function mlvNavPng(key, extraClass = 'h-6 w-6') {
  return mlvPng(key, `mlv-nav-png object-contain ${extraClass}`.trim(), { w: 24, h: 24 });
}
